import styled from "@emotion/styled";
import { MenuItem, Select, Stack, Typography } from "@mui/material";
import { LoadingScreen } from "components/LoadingScreen";
import { useChurchStore } from "features/churches";
import { useEffect, useState } from "react";
import { useBudgetYears, useTithesReport } from "../api";
import { StatCard } from "./Cards/StatCard";
import { TitheContributionsTable } from "./Tables/TitheContributionsTable";

const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
`;

export const TitheContributions = () => {
  const [budgetYear, setBudgetYear] = useState("");
  const [viewTitheContributions, setViewTitheContributions] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const selectedChurch = useChurchStore(state => state.selectedChurch);

  const { isLoading, data: tithesReport } = useTithesReport({
    churchId: selectedChurch?.id,
    budgetYearId: budgetYear,
    page,
    pageSize
  });

  const budgetYearsQuery = useBudgetYears({
    churchId: selectedChurch?.id
  });

  useEffect(() => {
    if (budgetYearsQuery.data?.result?.length > 0) {
      setBudgetYear(budgetYearsQuery.data?.result?.[0]?.id);
    }
  }, [budgetYearsQuery.data]);

  if (isLoading) return <LoadingScreen />;

  return (
    <Stack spacing={6}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography>Budget Year</Typography>
        {budgetYearsQuery.data?.result?.length > 0 && (
          <Select
            value={budgetYear}
            onChange={e => setBudgetYear(e.target.value)}
            size="small"
          >
            {budgetYearsQuery.data?.result?.map(year => (
              <MenuItem key={year.id} value={year.id}>
                {year.title}
              </MenuItem>
            ))}
          </Select>
        )}
      </Stack>
      <StatGrid>
        <StatCard
          title="Total Tithe Contributions"
          stat={tithesReport?.data?.grand_total || 0}
          description="Tithe Contributions"
          isVisible={viewTitheContributions}
          toggleVisibility={() =>
            setViewTitheContributions(!viewTitheContributions)
          }
        />
      </StatGrid>
      <TitheContributionsTable
        isLoading={isLoading}
        data={tithesReport?.data?.report}
        total={tithesReport?.total}
        page={page}
        setPage={setPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </Stack>
  );
};
